import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Link } from 'react-router-dom';
import { User } from 'lucide-react';

const UserMenu: React.FC = () => {
  const { user } = useAuth();

  // Get user profile for display name
  const { data: userProfile } = useQuery({
    queryKey: ["user-profile-menu", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      const { data, error } = await supabase
        .from("users")
        .select("first_name, last_name, handle")
        .eq('id', user.id)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    enabled: !!user?.id
  });

  const displayName = userProfile 
    ? `${userProfile.first_name || ''} ${userProfile.last_name || ''}`.trim() || userProfile.handle || user?.email?.split('@')[0]
    : user?.email?.split('@')[0] || 'User';
  const profileHref = userProfile?.handle ? `/p/${userProfile.handle}` : '/dashboard/settings';

  return (
    <div className="px-2 py-3 border-b border-border">
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm font-medium truncate">{displayName}</p>
        <Link 
          to={profileHref} 
          className="text-muted-foreground hover:text-foreground transition-colors"
          aria-label="View profile"
          title={userProfile?.handle ? 'View your public profile' : 'Set up your profile'}
        >
          <User className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};

export default UserMenu; 